export default "__VITE_ASSET__8$k1yKB___"